// Le a duracao do video ESCOLHIDO, no proprio navegador, antes do envio.
//
// Por que no cliente: medir a duracao aqui evita transcodificar o video no
// servidor so para descobrir esse numero -- transcodificacao esta explicitamente
// fora do escopo do ticket.
//
// Degradacao: se o navegador nao souber decodificar o container, o campo fica
// vazio e a aula salva mesmo assim. A duracao e informativa, nao e obrigatoria.

document.addEventListener("DOMContentLoaded", function () {
  const videoInput = document.querySelector("#lesson_video");
  const durationInput = document.querySelector("#lesson_duration_in_seconds");

  if (!videoInput || !durationInput) {
    return;
  }

  videoInput.addEventListener("change", function () {
    const file = videoInput.files && videoInput.files[0];

    if (!file) {
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    const probe = document.createElement("video");
    probe.preload = "metadata";

    probe.addEventListener("loadedmetadata", function () {
      if (isFinite(probe.duration)) {
        durationInput.value = Math.round(probe.duration);
      }
      URL.revokeObjectURL(objectUrl);
    });

    probe.addEventListener("error", function () {
      // Container ilegivel para este navegador: deixa o campo como esta.
      URL.revokeObjectURL(objectUrl);
    });

    probe.src = objectUrl;
  });
});
